import { InactiveHeader } from "src/components/inactive-header";
import { OffresFooter } from "../../offres-footer";
import { CarteLiberteDesktop } from "./main-deskop";
import { ChatbotSection } from "../../chatbot-section";
import { CarteLiberteMainMobile } from "./main-mobile";
import { DescriptionBanner } from "src/components/responsive/description-banner";
import { PriceIds } from "src/lib/utils";
import { Helmet } from "react-helmet";

export const CarteLiberteView = () => {
  return (
    <>
      <Helmet>
        <title>Carte Liberté - SNCF Connect</title>
      </Helmet>
      <InactiveHeader />
      <DescriptionBanner
        headerTitle="Carte Liberté"
        desktopImage="/carte_liberte.png"
        mobileImage="https://www.sncf-connect.com/assets/styles/scale_and_crop_360x214/public/media/2024-03/page_produit_grande_tetiere_1440x795.png?itok=6JPqsIP6"
        cardTitle="Carte Liberté"
        floatingDescription=""
        isStickyVisible
        badge="Promotion"
        badgeColor="#8de8fe"
        cardDescription=""
        price="19,95 €"
        buttonLabel="Commander la carte"
        href={`/app/offre/pricing/sncf?productId=${PriceIds["carte-liberte"]}`}
      />
      <CarteLiberteDesktop />
      <CarteLiberteMainMobile />
      <ChatbotSection />
      <OffresFooter />
    </>
  );
};
